export function getUtms(query: Types.PlainObject) {
  const utms: Types.PlainObject = {}

  for (const key in query) {
    if (key.toLowerCase().indexOf('utm_') === 0) {
      utms[key] = query[key]
    }
  }

  return utms
}
